import React from 'react';
import type {NativeStackScreenProps} from '@react-navigation/native-stack';
import {useTranslation} from 'react-i18next';

import {useAuthStore} from '@/entities/session/auth-store';
import type {SettingsStackParamList} from '@/app/routes';
import {MemberList} from '@/features/manage-members/ui/MemberList';
import {Page} from '@/shared/ui/page';
import {SettingsNav} from '@/pages/settings/SettingsNav';

/**
 * "Организация" → Дашборд → Участники. Who can administer the company (roles read-only)
 * plus the one write, remove access — guarded against self and owner inside MemberList.
 */
type Props = NativeStackScreenProps<SettingsStackParamList, 'Members'>;

export function MembersScreen(_: Props) {
  const {t} = useTranslation();
  const companyId = useAuthStore(s => s.activeContext?.companyId);
  return (
    <Page
      sideNav={<SettingsNav />}
      testID="company-members"
      title={t('dashboard.membersLink')}
      >
      {companyId ? <MemberList companyId={companyId} /> : null}
    </Page>
  );
}
